import React from "react";
import styled from "styled-components";
import { Flex, Text } from "../../assets/ui";
import { LocationsIcon } from "../../assets/icons";
import Theme from "../../assets/ui/theme";
import { withRouter } from "react-router-dom";
import {
  StyledRolesList,
  StyledRole,
  Description,
  StyledSectionWrapper
} from "./ui";

export const rolesData = [
  {
    type: "Sales",
    location: "UK",
    title: "Sales agent",
    prise: "70K – 100K per year",
    additionalInfo:
      "Exsportia is looking for good energy, etc etc e some text You will be your own boss and will be fully self employed – work when you want as long as your targets are met – hit your monthly target and take the month off. Completely target based room for more text about the role. The agent will be meeting Sports Venues and Personal trainers and showing them the benefits of usiong the Exsportia platform. Our agenst will get a 12 month rolling ",
    role:
      "Exsportia is looking for good energy, etc etc e some text You will be your own boss and will be fully self employed – work when you want as long as your targets are met – hit your monthly target and take the month off. Completely target based ( room for more text about the role. The agent will be meeting Sports Venues and Personal trainers and showing them the benefits of usiong the Exsportia platform. Our agenst will get a 12 month rolling "
  },
  {
    type: "Marketing",
    location: "Israel, Tel Aviv",
    title: "SMM Manager",
    prise: "70K – 100K per year",
    additionalInfo:
      "Exsportia is looking for good energy, etc etc e some text You will be your own boss and will be fully self employed – work when you want as long as your targets are met – hit your monthly target and take the month off. Completely target based room for more text about the role. The agent will be meeting Sports Venues and Personal trainers and showing them the benefits of usiong the Exsportia platform. Our agenst will get a 12 month rolling ",
    role:
      "Exsportia is looking for good energy, etc etc e some text You will be your own boss and will be fully self employed – work when you want as long as your targets are met – hit your monthly target and take the month off. Completely target based ( room for more text about the role. The agent will be meeting Sports Venues and Personal trainers and showing them the benefits of usiong the Exsportia platform. Our agenst will get a 12 month rolling "
  }
];

const OpenRoles = ({ history }) => {
  return (
    <StyledSectionWrapper>
      <Text
        fontSize={["14px"]}
        LineHeight={["17px"]}
        marginBottom={["14px", null, "10px"]}
        color={Theme.colors.subTitle}
      >
        Open roles
      </Text>
      <Text
        fontSize={["28px", null, "48px"]}
        LineHeight={["35px", null, "59px"]}
        color={Theme.colors.white}
        fontWeight="bold"
      >
        We are hiring for:
      </Text>

      <Flex
        flexDirection={["column", `${rolesData.length === 1 ? "row" : null}`]}
        alignItems={[
          "flex-start",
          `${rolesData.length === 1 ? "center" : null}`
        ]}
      >
        <StyledRolesList
          width={["100%", `${rolesData.length === 1 ? "410px" : null}`]}
        >
          {rolesData.map((el, index) => {
            return (
              <Flex
                flexDirection="column"
                key={index}
                width={["100%"]}
                maxWidth={["inherit", null, "320px"]}
                marginRight={[
                  "0px",
                  `${
                    rolesData.length !== 1 && index !== rolesData.length - 1
                      ? "30px"
                      : "0px"
                  }`,
                  null,
                  `${
                    rolesData.length !== 1 && index !== rolesData.length - 1
                      ? "68px"
                      : "0px"
                  }`
                ]}
                marginBottom={[`${rolesData.length === 1 ? 0 : "24px"}`]}
              >
                <Text
                  fontSize={["24px", null, "32px"]}
                  LineHeight={["30px", null, "40px"]}
                  color={Theme.colors.white}
                  marginBottom={["44px", null, "72px"]}
                  fontWeight="bold"
                >
                  {el.type}
                </Text>
                <StyledRole>
                  <span className="location">
                    <LocationsIcon />
                    {el.location}
                  </span>
                  <h4>{el.title}</h4>
                  <p>{el.prise}</p>

                  <button
                    onClick={() => {
                      window.scrollTo(0, 0);
                      history.push(`/work-with-us/${index}`);
                    }}
                  >
                    See Details
                  </button>
                </StyledRole>
              </Flex>
            );
          })}
        </StyledRolesList>
        <Description
          maxWidth={["inherit", `${rolesData.length === 1 ? "310px" : null}`]}
        >
          We’re growing the team and would love you to join us on our adventure
        </Description>
      </Flex>
    </StyledSectionWrapper>
  );
};

export default withRouter(OpenRoles);
